import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { UtilsContext } from '../../provider/utils/context';
import { isValidHttpUrl } from '../../utils/isValidUrl/isValidUrl';
import { ErrorBoundary } from '../../provider/errorBoundary/errorBoundary';
import { IconBasic } from './icon';
const IconWithProvider = ({ urlFallbackIcon, urlIcon, ...props }) => {
    const [resolvedIcon, setResolvedIcon] = React.useState(urlIcon);
    React.useEffect(() => {
        if (urlFallbackIcon) {
            const fetchIcon = async () => {
                try {
                    const response = await fetch(urlIcon, { cache: 'no-store' });
                    if (!response.ok)
                        throw new Error('Error loading icon');
                    setResolvedIcon(urlIcon);
                }
                catch (error) {
                    setResolvedIcon(urlFallbackIcon);
                }
            };
            fetchIcon();
        }
        else {
            setResolvedIcon(urlIcon);
        }
    }, [urlIcon, urlFallbackIcon]);
    return _jsx(IconBasic, { ...props, ref: props.ref, icon: resolvedIcon });
};
const IconHostComponent = ({ fallbackIcon, ...props }, ref) => {
    const myContext = React.useContext(UtilsContext);
    const isUrl = isValidHttpUrl(props.icon);
    const { ICONS_STYLES } = useTheme();
    const urlIcon = isUrl
        ? props.icon
        : `${myContext?.assets?.iconsBaseHost}${ICONS_STYLES?.[props.icon]}`;
    let urlFallbackIcon;
    if (fallbackIcon) {
        const isUrlFallbackIcon = isValidHttpUrl(fallbackIcon);
        urlFallbackIcon = isUrlFallbackIcon
            ? fallbackIcon
            : `${myContext?.assets?.iconsBaseHost}${ICONS_STYLES?.[fallbackIcon]}`;
    }
    return (_jsx(ErrorBoundary, { fallBackComponent: _jsx(_Fragment, {}), resetCondition: props.icon, children: _jsx(IconWithProvider, { ...props, ref: ref, urlFallbackIcon: urlFallbackIcon, urlIcon: urlIcon }) }));
};
export const IconHost = React.forwardRef(IconHostComponent);
//# sourceMappingURL=iconHost.js.map